import React, {useState} from "react";
import {useLocalization} from "../../../i18n";
import {
	Button,
	Checkbox,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	FormControlLabel,
	FormGroup, Stack
} from "@mui/material";
import {useFlag} from "@variocube/app-ui";

interface BookingOpenButtonProps {
	disabled: boolean;
	releaseWarning: boolean;
	onOpen: () => void;
}

export function BookingOpenButton({disabled, releaseWarning, onOpen}: BookingOpenButtonProps) {
	const {t} = useLocalization();

	const [open, setOpen, clearOpen] = useFlag(false);
	const [firstAcceptance, setFirstAcceptance] = useState(false);
	const [secondAcceptance, setSecondAcceptance] = useState(false);
	const [thirdAcceptance, setThirdAcceptance] = useState(false);

	const allTermsAccepted = firstAcceptance && secondAcceptance && thirdAcceptance;

	const acceptanceRows = [
		{
			label: t('booking.simplified.boxOpening.firstAcceptance'),
			value: firstAcceptance,
			onChange: setFirstAcceptance
		},
		{
			label: t('booking.simplified.boxOpening.secondAcceptance'),
			value: secondAcceptance,
			onChange: setSecondAcceptance
		},
		{
			label: releaseWarning ? t('booking.simplified.boxOpening.thirdAcceptanceExpired') : t('booking.simplified.boxOpening.thirdAcceptance'),
			value: thirdAcceptance,
			onChange: setThirdAcceptance
		}
	];

	function handleOpen() {
		clearOpen();
		onOpen();
	}

	return (
		<>
			<Button
				variant="contained"
				color="primary"
				disableElevation
				onClick={setOpen}
				disabled={disabled}
			>
				{t('booking.simplified.boxOpening.cta')}
			</Button>
			<Dialog
				open={open}
				fullWidth
				maxWidth="sm"
				onClose={clearOpen}
			>
				<DialogTitle>{t('booking.simplified.boxOpening.title')}</DialogTitle>
				<DialogContent
					sx={{
						minHeight: "calc(50vh)",
					}}
				>
					{acceptanceRows.map(({label, value, onChange}, i) => (
						<FormGroup
							key={'acceptance-' + i}
							row
						>
							<FormControlLabel
								control={<Checkbox
									checked={value}
									onChange={ev => onChange(ev.target.checked)}
									color="primary"
								/>}
								label={label}
							/>
						</FormGroup>
					))}
				</DialogContent>
				<DialogActions>
					<Stack
						direction="column"
						alignItems="center"
						gap={1}
					>
						<Button
							fullWidth
							variant="contained"
							color="primary"
							disableElevation
							onClick={handleOpen}
							disabled={!allTermsAccepted}
						>
							{t('booking.simplified.boxOpening.cta')}
						</Button>
						<Button
							fullWidth
							size="small"
							variant="outlined"
							color="primary"
							disableElevation
							onClick={clearOpen}
						>
							{t('actions.close')}
						</Button>
					</Stack>
				</DialogActions>
			</Dialog>
		</>
	)
}
